<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-button autoHide="false"></ion-menu-button>
      <ion-back-button defaultHref="/driver/queue"></ion-back-button>
    </ion-buttons>
    <ion-title>Pay Platform</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-card>
    <ion-card-header>
      <ion-card-subtitle>Outstanding balance</ion-card-subtitle>
      <ion-card-title>${{ balanceAmount.toFixed(2) }}</ion-card-title>
    </ion-card-header>
  </ion-card>

  <h3 class="ion-padding-top">Choose a payment method</h3>

  <ion-grid>
    <ion-row>
      <ion-col size="6">
        <ion-card
          button
          (click)="selectMethod('stripe')"
          [color]="selectedMethod === 'stripe' ? 'primary' : ''"
        >
          <ion-card-content class="ion-text-center">
            <ion-icon name="card-outline" size="large"></ion-icon>
            <p>Card (Stripe)</p>
          </ion-card-content>
        </ion-card>
      </ion-col>
      <ion-col size="6">
        <ion-card
          button
          (click)="selectMethod('zelle')"
          [color]="selectedMethod === 'zelle' ? 'primary' : ''"
        >
          <ion-card-content class="ion-text-center">
            <ion-icon name="cash-outline" size="large"></ion-icon>
            <p>Zelle</p>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>
  </ion-grid>

  <div *ngIf="selectedMethod === 'stripe'" class="ion-padding-top">
    <ion-button expand="block" (click)="payWithStripe()" [disabled]="balanceAmount <= 0">
      <ion-icon name="card-outline" slot="start"></ion-icon>
      Pay with card
    </ion-button>
  </div>

  <form
    *ngIf="selectedMethod === 'zelle'"
    [formGroup]="zelleForm"
    (ngSubmit)="submitZelle()"
    class="ion-padding-top"
  >
    <ion-list>
      <ion-item>
        <ion-label position="stacked">Zelle reference number</ion-label>
        <ion-input
          type="text"
          formControlName="referencia"
          placeholder="e.g. 1234-ABCD"
        ></ion-input>
      </ion-item>
      <ion-item>
        <ion-label position="stacked">Amount paid (USD)</ion-label>
        <ion-input type="number" formControlName="valor" step="0.01"></ion-input>
      </ion-item>
      <ion-item>
        <ion-label position="stacked">Receipt (PNG, JPG, PDF — max 5MB)</ion-label>
        <input type="file" accept="image/png,image/jpeg,application/pdf" (change)="onFileSelected($event)" />
      </ion-item>
    </ion-list>

    <ion-button
      type="submit"
      expand="block"
      class="ion-margin-top"
      [disabled]="zelleForm.invalid || !selectedFile || submittingZelle"
    >
      <ion-icon name="cloud-upload-outline" slot="start"></ion-icon>
      Submit Zelle payment
    </ion-button>
    <p class="ion-text-center ion-padding-top">
      <small>
        Your submission will be reviewed by the platform team before it
        clears your balance.
      </small>
    </p>
  </form>
</ion-content>
